/**
 * Empty list or panel placeholder with optional primary action slot.
 *
 * @param options - Title, body copy, and optional action node (for example a **`Button`**).
 * @returns Container with **`qz-empty`** layout.
 */
export function createEmptyState(
  options: Readonly<{
    title: string;
    body: string;
    action?: HTMLElement;
  }>,
): HTMLDivElement {
  const root = document.createElement("div");
  root.className = "qz-empty";

  const h = document.createElement("h3");
  h.className = "qz-empty__title";
  h.textContent = options.title;
  root.appendChild(h);

  const p = document.createElement("p");
  p.className = "qz-empty__body";
  p.textContent = options.body;
  root.appendChild(p);

  if (options.action !== undefined) {
    const slot = document.createElement("div");
    slot.className = "qz-empty__action";
    slot.appendChild(options.action);
    root.appendChild(slot);
  }

  return root;
}
